import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=5924ad49&scoped=true&"
import script from "./Compare.vue?vue&type=script&lang=js&"
export * from "./Compare.vue?vue&type=script&lang=js&"
import style0 from "./Compare.vue?vue&type=style&index=0&id=5924ad49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5924ad49",
  null
  
)

export default component.exports